<app-navbar></app-navbar>
<div class="content-wrapper">
    <router-outlet></router-outlet>
</div>

<app-footer></app-footer>
